/* ==========================================================================
   smellBgone Load-more pagination — ports the Hydrogen PaginatedResourceSection
   "↑ Load previous" / "Load more ↓" UX (app/components/PaginatedResourceSection)
   to Liquid using the Shopify Section Rendering API.

   Progressive enhancement: the prev/next controls are real <a href="?page=N">
   links, so with JS disabled they navigate normally (a full page load). With
   JS, a click fetches "<href>&section_id=<id>", parses the returned section
   markup, and appends (next) / prepends (previous) the new grid items in place,
   then updates the controls from the fetched response.

   Markup contract (per section root [data-loadmore]):
     data-section-id           — the section id (for the Section Rendering API)
     [data-loadmore-grid]      — the container whose children are the items
     [data-loadmore-next]      — the "Load more" anchor (or absent on last page)
     [data-loadmore-prev]      — the "Load previous" anchor (or absent on first)
   ========================================================================== */
(function () {
  function withSection(href, id) {
    if (!href) return null;
    return href + (href.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(id);
  }

  function initRoot(root) {
    if (root.__smbLoadMoreInit) return;
    root.__smbLoadMoreInit = true;

    var sectionId = root.getAttribute('data-section-id');
    var grid = root.querySelector('[data-loadmore-grid]');
    if (!sectionId || !grid) return;

    function bind() {
      var next = root.querySelector('[data-loadmore-next]');
      var prev = root.querySelector('[data-loadmore-prev]');
      if (next)
        next.addEventListener('click', function (e) {
          handle(e, next, 'next');
        });
      if (prev)
        prev.addEventListener('click', function (e) {
          handle(e, prev, 'prev');
        });
    }

    function handle(e, link, dir) {
      if (!window.fetch || !window.DOMParser) return; // no-JS/legacy: normal navigation
      e.preventDefault();
      var url = withSection(link.getAttribute('href'), sectionId);
      if (!url) return;
      var label = link.querySelector('span');
      var prevText = link.innerHTML;
      link.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'Loading...';

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newRoot = doc.querySelector('[data-loadmore]');
          var newGrid = newRoot && newRoot.querySelector('[data-loadmore-grid]');
          if (!newGrid) {
            window.location.href = link.getAttribute('href');
            return;
          }

          var items = Array.prototype.slice.call(newGrid.children);
          if (dir === 'prev') items.reverse();
          items.forEach(function (node) {
            if (dir === 'next') grid.appendChild(node);
            else grid.insertBefore(node, grid.firstChild);
          });

          // Swap the control we just used for the fetched page's equivalent, so
          // the next click walks to the following page (or the control vanishes).
          var replacement = newRoot.querySelector(dir === 'next' ? '[data-loadmore-next]' : '[data-loadmore-prev]');
          if (replacement) {
            link.parentNode.replaceChild(replacement, link);
            replacement.addEventListener('click', function (ev) {
              handle(ev, replacement, dir);
            });
          } else {
            link.parentNode.removeChild(link);
          }
        })
        .catch(function () {
          link.innerHTML = prevText;
          link.removeAttribute('aria-busy');
        });
    }

    bind();
  }

  function scan() {
    document.querySelectorAll('[data-loadmore]').forEach(initRoot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-loadmore]').forEach(initRoot);
  });
  // smb-shop-filter.js swaps a filtered list in place and fires this on its
  // root, so the new list's Load more link is wired like the first one was.
  document.addEventListener('smb:section:refresh', function (e) {
    e.target.querySelectorAll('[data-loadmore]').forEach(initRoot);
  });
})();
